import { AuthenticationConstans } from "../Constants";
import { BlankString } from "../Constants";
import jwt_decode from "jwt-decode";
import IUserInfo from "../components/pages/models/interfaces/IUserInfo";
import { lazy } from "react";
export function GetStorageItem(key: string): string | null {
  return localStorage.getItem(key);
};

export function SetStorageItem (key: string, value: string) {
  localStorage.setItem(key, value);
};

export function ClearStorage() {
  localStorage.removeItem(AuthenticationConstans.Identity);
};

export function GetUserRoles(): string[] {
  let roles : string[] = [];
  let identityString: string | null = BlankString;
  if (GetStorageItem(AuthenticationConstans.Identity) !== null) {
    identityString = GetStorageItem(AuthenticationConstans.Identity);
    const identity = JSON.parse(identityString!);
    const decoded_token: any = jwt_decode(identity.token);
    roles = Array.isArray(decoded_token.role) ? decoded_token.role : [decoded_token.role];
  }
  return roles;
};

export function SetMenuRestoredStatus(status: boolean) {
  const identityString : string | null = GetStorageItem(AuthenticationConstans.Identity);
  const identity : IUserInfo = JSON.parse(identityString!);
  identity.menu = status;
  SetStorageItem(AuthenticationConstans.Identity, JSON.stringify(identity));
};

export function HasRole(role: string): boolean {
  const roles = GetUserRoles();
  return roles.includes(role);
};

export function GetAccessToken(): string {
  let identityString: string | null = BlankString;
  if (GetStorageItem(AuthenticationConstans.Identity) !== null) {
    identityString = GetStorageItem(AuthenticationConstans.Identity);
  }
  const identity = JSON.parse(identityString!);
  return identity.token;
};

export function GetMenuRestoredStatus(): boolean{
  let identityString: string | null = BlankString;
  if (GetStorageItem(AuthenticationConstans.Identity) !== null) {
    identityString = GetStorageItem(AuthenticationConstans.Identity);
  }
  if(identityString) {
    const identity : IUserInfo = JSON.parse(identityString!);
    return identity === undefined ? false : identity.menu;
  }
  return false;
};

export function iOSDevice(): boolean {
  return navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null;
};

export function lazyLoad(componentWithPath: string, namedExport: string | undefined = undefined) {
  return lazy(async () => {
    const promise = import(`../components/${componentWithPath}`);
    if(namedExport === null || namedExport === undefined) return promise;
    const module = await promise;
    return ({
      default: module[namedExport]
    });
  });
};